module.exports = __webpack_public_path__ + "img/search.78dd6803.png";